import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'pipeDurationStatus'
})
export class PipeDurationStatus implements PipeTransform {
    constructor() {}

    transform(event) {
        if(event && event.desk){

            if(moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()){
                if (event.desk && event.desk.space && event.desk.space.default && 
                    event.desk.locale && event.desk.locale.checkin && event.checkin) {
                        let diff: any = this.diff(event, event.end);
                        return this.message(diff, 'Termina');
                } else if (event.desk && event.desk.space && !event.desk.space.default && 
                    event.desk.space.checkin && event.checkin) {
                        let diff: any = this.diff(event, event.end);
                        return this.message(diff, 'Termina');
                } else if ((event.desk && event.desk.space && event.desk.space.default && 
                    event.desk.locale && !event.desk.locale.checkin) || 
                    (event.desk && event.desk.space && !event.desk.space.default && 
                    !event.desk.space.checkin)) {
                        let diff: any = this.diff(event, event.end);
                        return this.message(diff, 'Termina');
                } else {
                    return "Aguardando Check-In";
                }
            } else {
                let diff: any = this.diff(event, event.start);
                return this.message(diff, 'Inicia');
            }
            
        } else if (event && event.meetingrooms && event.meetingrooms.length > 0) {

            if (moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()) {
                if (event.meetingrooms[0] && event.meetingrooms[0].space && event.meetingrooms[0].space.default && 
                    event.meetingrooms[0].locale && event.meetingrooms[0].locale.checkin && (event.checkin || (event.scheduleOffice && event.scheduleOffice.checkinAt))) {
                        let diff: any = this.diff(event, event.end);
                        return this.message(diff, 'Termina');
                } else if (event.meetingrooms[0] && event.meetingrooms[0].space && !event.meetingrooms[0].space.default && 
                    event.meetingrooms[0].space.checkin && (event.checkin || (event.scheduleOffice && event.scheduleOffice.checkinAt))) {
                        let diff: any = this.diff(event, event.end);
                        return this.message(diff, 'Termina');
                } else if ((event.meetingrooms[0] && event.meetingrooms[0].space && event.meetingrooms[0].space.default && 
                    event.meetingrooms[0].locale && !event.meetingrooms[0].locale.checkin) || 
                    (event.meetingrooms[0] && event.meetingrooms[0].space && !event.meetingrooms[0].space.default && 
                    !event.meetingrooms[0].space.checkin)) {
                        let diff: any = this.diff(event, event.end);
                        return this.message(diff, 'Termina');
                } else {
                    return "Aguardando Check-In";
                }
            } else {
                let diff: any = this.diff(event, event.start);
                return this.message(diff, 'Inicia');
            }
            
        } else if (event) {
            if(moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()) {
                let diff: any = this.diff(event, event.end);
                return this.message(diff, 'Termina');
            } else {
                let diff: any = this.diff(event, event.start);
                return this.message(diff, 'Inicia');
            }
        } else return '';
    }

    diff(event, when) {
        event.diff = moment(when).diff(moment(), 'minutes');
        return (event.diff > 58 ? (Math.round(event.diff / 60) + ' h') : (event.diff + 1) + ' min');
    }

    message(diff, context) {
        return diff.split(' ')[0] > 0 ? context + ' em ' + diff : 'Terminou';
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeDurationStatus.ts